import { render, staticRenderFns } from "./IRLExplainModal.vue?vue&type=template&id=6c266f6c&scoped=true"
import script from "./IRLExplainModal.vue?vue&type=script&lang=js"
export * from "./IRLExplainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c266f6c",
  null
  
)

export default component.exports